import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {useModalCreateTicket} from "@dropDesk/presentation/pages/ticket/ui/form_create/modals/handle_change_visible";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import FormClients from "@dropDesk/presentation/pages/client/ui/my_clients/form_client";
import {ContentFormCreate} from "@dropDesk/presentation/pages/ticket/ui/form_create/modals/styled";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";

const ModalsOfSearch = observer(
    ({
         onCreateClient,
         onEditClient,
         client,
         isEdit,
     }: {
        onCreateClient: (client: ClientEntity) => boolean,
        onEditClient: (client: ClientEntity) => void,
        client: ClientEntity | undefined,
        isEdit?: boolean,
    }) => {

        const {
            visibleModalCreateClient, setVisibleModalCreateClient
        } = useBetween(useModalCreateTicket);


        return (
            <>
                <ModalMain
                    open={visibleModalCreateClient}
                    onRequestClose={() => setVisibleModalCreateClient(false)}
                    width={1060}
                    renderComponent={
                        <ContentFormCreate>
                            <FormClients
                                isEdit={true}
                                idClientExternal={client?.id ?? ''}
                                handleSubmitExternalScreen={async (client) => {
                                    if (isEdit) {
                                        onEditClient(client);
                                    } else {
                                        onCreateClient(client);
                                        setVisibleModalCreateClient(false);
                                    }
                                }}
                                backPreviousScreenExternalScreen={() => setVisibleModalCreateClient(false)}
                            />
                        </ContentFormCreate>}
                />


            </>
        )
    })
export default ModalsOfSearch;
